import {Button, Input, Switch, Upload, message} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import React from "react";
import EntityApi from "../../../api/EntityApi";
import QuestionForm from "./QuestionForm";
import AnswerForm from "./AnswerForm";
import config from '../../../api/config'


const { TextArea } = Input;

const TestingForm = ({materialId, productId, chapterId, onReloadList}) => {

    const [isOpenQuestionForm, setOpenQuestionForm] = React.useState(false);
    const [selectQuestionId, setSelectQuestionId] = React.useState(null);
    const [editAnswerId, setEditAnswerId] = React.useState(null);
    const [isShowConstructor, setShowConstructor] = React.useState(false);
    const [isReload, setIsReload] = React.useState(false);

    // form testing
    const [formId, setFormId] = React.useState(null);
    const [formName, setFormName] = React.useState('');
    const [formDescription, setFormDescription] = React.useState('');
    const [formNumberSuccess, setFormNumberSuccess] = React.useState(null);
    const [formAttempts, setFormAttempts] = React.useState(null);
    const [formPeriod, setFormPeriod] = React.useState(null);
    const [formExam, setFormExam] = React.useState(false);
    const [formIsGrade, setFormIsGrade] = React.useState(false);
    const [formIsShowInfo, setFormIsShowInfo] = React.useState(false);
    const [isFormLoading, setFormLoading] = React.useState(false);
    const [grade5, setGrade5] = React.useState(null);
    const [grade4, setGrade4] = React.useState(null);
    const [grade3, setGrade3] = React.useState(null);

    const [questions, setQuestions] = React.useState([]);
    const [answers, setAnswers] = React.useState([]);

    const setFormAttemptsNumber = (value) => {
        let num = value.replace(/\D/g, '');
        setFormAttempts(num);
    }

    const setFormPeriodNumber = (value) => {
        let num = value.replace(/\D/g, '');
        setFormPeriod(num);
    }

    const setFormNumberSuccessNumber = (value) => {
        let num = value.replace(/\D/g, '');
        setFormNumberSuccess(num);
    }

    const setFormGrade = (value, grade) => {
        let num = value.replace(/\D/g, '');
        if (grade === 5) {
            setGrade5(num);
        }
        if (grade === 4) {
            setGrade4(num);
        }
        if (grade === 3) {
            setGrade3(num);
        }
    }

    const onFormReset = () => {
        setFormName('');
        setFormDescription('');
        setFormAttempts(null);
        setFormPeriod(null);
        setFormExam(false);
        setQuestions([]);
        setAnswers([]);
        setSelectQuestionId(null);
        setShowConstructor(false);
        setFormId(null);
        setFormNumberSuccess(null);
    }

    const onTestingLoad = (materialId, testingId) => {

        if (!materialId && !testingId) return;

        setFormLoading(true);

        EntityApi.getBy('private/testing', {
            filter: {
                material: materialId,
                id: testingId
            }
        }).then((data) => {
            setFormLoading(false);
            if (data.status === EntityApi.STATUS_SUCCESS && data.content.items !== undefined && data.content.items) {
                data.content.items.forEach((item) => {
                    setFormId(item.id);
                    setFormName(item.name);
                    setFormNumberSuccess(item.number_success);
                    setFormDescription(item.description);
                    setFormAttempts(item.attempts);
                    setFormPeriod(item.period);
                    setFormExam(item.is_exam);
                    setFormIsShowInfo(item.is_show_info);
                    setFormIsGrade(item.is_grade);
                    setGrade5(null);
                    setGrade4(null);
                    setGrade3(null);
                    if (item.grades.grade5 !== undefined) {
                        setGrade5(item.grades.grade5);
                    }
                    if (item.grades.grade4 !== undefined) {
                        setGrade4(item.grades.grade4);
                    }
                    if (item.grades.grade3 !== undefined) {
                        setGrade3(item.grades.grade3);
                    }
                    setQuestions(item.questions);
                    setShowConstructor(true);
                    setAnswers([]);
                    setSelectQuestionId(null);
                })
            }
        }).catch(() => {
            setFormLoading(false);
        })

    }
    const onTestingSave = () => {

        if (formName === '') {
            message.error('Введите название тестирования');
            return false;
        }

        if (formIsGrade && (grade5 <= 1 || grade4 <= 1 || grade3 <= 1)) {
            message.error('Укажите кол-во ответов для оценки');
            return false;
        }

        console.log(
            productId, chapterId, formName, formDescription, formAttempts, formPeriod, formExam
        );

        setFormLoading(true);

        let url = 'private/testing';
        if (formId > 0) {
            url += '/' + formId;
        }

        EntityApi.put(url, {
            "product": productId,
            "chapter": chapterId,
            "name": formName,
            "description": formDescription,
            "number_success": formNumberSuccess,
            "attempts": formAttempts,
            "period": formPeriod,
            "is_exam": formExam,
            "is_show_info": formIsShowInfo,
            "is_grade": formIsGrade,
            "grades": {
                "grade5": grade5,
                "grade4": grade4,
                "grade3": grade3
            }
        }).then((data) => {
            setFormLoading(false);
            if (data.status === EntityApi.STATUS_SUCCESS) {
                setFormId(data.content.item.id);
                onReloadList();
            } else {
                message.error('Ошибка сохранения');
            }
        }).catch((error) => {
            setFormLoading(false);
            message.error(error.message);
        })

    }

    React.useEffect(() => {
       if (formId > 0) {
           setShowConstructor(true);
       } else {
           setShowConstructor(false);
       }
    }, [formId]);

    React.useEffect(() => {
        console.log('tm ' + materialId);
        if (materialId !== undefined && materialId > 0) {
            onFormReset();
            onTestingLoad(materialId);
        } else {
            setFormId(null);
            onFormReset();
        }
    }, [materialId]);

    // questions
    const [questionId, setQuestionId] = React.useState(null);
    const [questionText, setQuestionText] = React.useState('');
    const [questionInfo, setQuestionInfo] = React.useState('');
    const [questionImage, setQuestionImage] = React.useState('');

    const propsUpload = {
        name: 'file',
        action: config.host + '/api/private/file',
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token')
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log('!!!uploading');
                //console.log(info.file, info.fileList);
                if (info.file.response.content.item !== undefined) {
                    setQuestionImage(info.file.response.content.item.url);
                }
            }
            if (info.file.status === 'done') {
                message.success(`${info.file.name} file uploaded successfully`);
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
        maxCount: 1
    };

    const onQuestionSave = () => {

        if (questionText === '') {
            message.error('Введите текст вопроса');
            return false;
        }

        EntityApi.put('private/testing/question', {
            testing: formId,
            text: questionText,
            info: questionInfo,
            image: questionImage,
        }).then((data) => {
            if (data.status === EntityApi.STATUS_SUCCESS) {
                setIsReload(!isReload);
                setQuestionText('');
                setQuestionInfo('');
                setQuestionImage('');
                setOpenQuestionForm(false);
            }
        }).catch((error) => {
            message.error(error.message);
        })

    }

    React.useEffect(() => {
        setAnswers([]);
        setSelectQuestionId(null);
        onTestingLoad(null, formId);
    }, [isReload])

    // answers
    const [answerText, setAnswerText] = React.useState('');
    const onLoadAnswers = () => {
        setAnswers([]);
        EntityApi.getBy('private/testing/answer', {
            filter: {
                question: selectQuestionId
            }
        }).then((data) => {
            if (data.status === EntityApi.STATUS_SUCCESS) {
                if (data.content.items !== undefined) {
                    setAnswers(data.content.items);
                    let tmpQuestions = questions;
                    tmpQuestions.forEach((question, index) => {
                        if (question.id === selectQuestionId) {
                            tmpQuestions[index].answers_count = data.content.items.length;
                        }
                    })
                    setQuestions(tmpQuestions);
                }
            }
        })
    }

    const onAnswerSave = () => {
        if (answerText === '') {
            message.error('Введите текст ответа');
            return false;
        }

        EntityApi.put('private/testing/answer', {
            testing: formId,
            question: selectQuestionId,
            text: answerText,
        }).then((data) => {
            if (data.status === EntityApi.STATUS_SUCCESS) {
                setAnswerText('');
                onLoadAnswers();
            }
        }).catch((error) => {
            message.error(error.message);
        })
    }

    React.useEffect(() => {
        if (selectQuestionId > 0) {
            setAnswerText('');
            onLoadAnswers();
        } else {
            setAnswerText('');
            setAnswers([]);
        }
    }, [selectQuestionId])


    return  <>
        {
            isFormLoading &&
            <div style={{top: '0px', left: '0px'}} className="app-preloader absolute opacity-50 z-50 grid h-full w-full place-content-center bg-slate-50 dark:bg-navy-900">
                <div className="app-preloader-inner relative inline-block h-48 w-48"></div>
            </div>
        }
        <div className={'flex w-full'}>
            <div className={'w-full'}>
                <Input value={formName} onChange={(e) => setFormName(e.target.value)} placeholder={'Название тестирования'}/>
            </div>
        </div>
        <div className={'mt-3'}>
            <TextArea value={formDescription} onChange={(e) => setFormDescription(e.target.value)} placeholder={'Описание задания'}/>
        </div>
        <div className={'mt-3 flex justify-end '}>
            <div className={'pr-3'}>
                <Switch checked={formIsShowInfo} checkedChildren="С колонкой инфо" unCheckedChildren="Без колонки инфо"
                        onChange={(value) => setFormIsShowInfo(value)}/>
            </div>
            <div className={'pr-3'}>
                <Switch checked={formIsGrade} checkedChildren="С оценкой" unCheckedChildren="Без оценки"
                        onChange={(value) => setFormIsGrade(value)}/>
            </div>
            {
                formIsGrade &&
                <div className={'pr-3'} style={{width: '100px'}}>
                    <Input value={grade5} onChange={(e) => setFormGrade(e.target.value, 5)}
                           placeholder={'0'}/> Отлично
                </div>
            }
            {
                formIsGrade &&
                <div className={'pr-3'} style={{width: '100px'}}>
                    <Input value={grade4} onChange={(e) => setFormGrade(e.target.value, 4)}
                           placeholder={'0'}/> Хорошо
                </div>
            }
            {
                formIsGrade &&
                <div className={'pr-3'} style={{width: '100px'}}>
                    <Input value={grade3} onChange={(e) => setFormGrade(e.target.value, 3)}
                           placeholder={'0'}/> Удовл.
                </div>
            }
            <div className={'pr-3'}>
                <Switch checked={formExam} checkedChildren="Экзамен" unCheckedChildren="Тестирование"
                        onChange={(value) => setFormExam(value)}/>
            </div>
            <div className={'pr-3'} style={{width: '250px'}}>
                <Input value={formNumberSuccess} onChange={(e) => setFormNumberSuccessNumber(e.target.value)}
                       placeholder={'Кол-во'}/> Допустимое кол-во ошибок
            </div>
            <div className={'pr-3'} style={{width: '100px'}}>
                <Input value={formAttempts} onChange={(e) => setFormAttemptsNumber(e.target.value)}
                       placeholder={'Кол-во'}/> Попытки
            </div>
            <div className={'pr-3'} style={{width: '100px'}}>
                <Input value={formPeriod} onChange={(e) => setFormPeriodNumber(e.target.value)}
                       placeholder={'Минуты'}/> Время
            </div>
            <Button type={'primary'} onClick={onTestingSave}>{
                formId > 0 ? 'Сохранить' : 'Создать'
            }</Button>
        </div>

        {
            isShowConstructor &&
            <div className={'flex w-full p-4 mt-3'} style={{background: '#f8fafc', borderTop: '1px solid #d9d9d9'}}>
                <div className={'w-6/12 mr-3'}>
                    <div className={'card p-4'}>
                        {
                            questions.map((question, index) => (
                                <QuestionForm
                                    reload={() => setIsReload(!isReload)}
                                    key={question.id}
                                    question={question}
                                    index={index}
                                    questions={questions}
                                    onSelect={() => setSelectQuestionId(question.id)}
                                    selected={selectQuestionId === question.id}
                                />
                            ))
                        }
                    </div>
                    <div className={'card p-4 mt-3'}>
                        {
                            isOpenQuestionForm ?
                                <div>
                                    <div className={'font-bold pb-2'}>Добавить новый вопрос</div>
                                    <div className={'pb-1'}>Текст вопроса</div>
                                    <TextArea value={questionText} onChange={(e) => setQuestionText(e.target.value)}
                                              placeholder={'Текст вопроса'}/>
                                    <div className={'pt-1'}>
                                        <div className={'pb-1'}>Информация</div>
                                        <TextArea value={questionInfo} onChange={(e) => setQuestionInfo(e.target.value)}/>
                                    </div>
                                    <div className={'mt-3'}>
                                        <Upload {...propsUpload}>
                                            <Button icon={<UploadOutlined/>}>Загрузить изображение вопроса</Button>
                                        </Upload>
                                        {
                                            questionImage !== '' &&
                                            <div className={'mt-3'}><img src={questionImage}/></div>
                                        }
                                    </div>
                                    <div className={'flex justify-end mt-3'}>
                                        <Button onClick={() => setOpenQuestionForm(false)} className={'mr-3'}
                                                type={'default'}>Отмена</Button>
                                        <Button type={'primary'} onClick={onQuestionSave}>Создать вопрос</Button>
                                    </div>
                                </div>
                                :
                                <div className={'w-4/12'}>
                                    <Button type={'primary'} onClick={() => setOpenQuestionForm(true)}>Добавить
                                        вопрос</Button>
                                </div>
                        }
                    </div>
                </div>
                <div className={'w-6/12'} style={{minHeight: '500px'}}>
                    {
                        selectQuestionId > 0 &&
                        <div className={'card p-4'} style={{position: 'fixed', width: '40%'}}>
                            <div style={{marginBottom: '0.75rem'}}>
                                <TextArea value={answerText} onChange={(e) => setAnswerText(e.target.value)}
                                          placeholder={'Введите текст ответа'}></TextArea>
                                <div className={'mt-3 text-right'}>
                                    <Button onClick={onAnswerSave} type={'primary'}>Добавить ответ</Button>
                                </div>
                            </div>
                            {
                                answers.map((answer, index) => (
                                    <AnswerForm
                                        key={answer.id}
                                        reload={() => onLoadAnswers()}
                                        answer={answer}
                                        index={index}
                                        answers={answers}/>
                                ))
                            }
                        </div>
                    }
                </div>
            </div>
        }

    </>

}

export default TestingForm;
